import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import BoilerplateForm from './boilerplate_form';

import { html, nothing } from 'lit';

export class GiveawayAdditionalForm extends BoilerplateForm {
  static get properties() {
    return {
      currentOrder: {
        type: Object,
        attribute: 'current-order',
        converter: (value) => JSON.parse(value),
      },
      customerId: {
        type: String,
        attribute: 'customer-id',
      },
      giveawayHandle: {
        type: String,
        attribute: 'giveaway-handle',
        reflect: false,
      },
    };
  }

  constructor() {
    super();

    document.addEventListener('order-selected', () => {
      this.updateFormState('initial');
    });
  }

  async handleSubmit(event) {
    event.preventDefault();

    const body = {
      ...this.objectData,
      config: this.region,
      giveawayHandle: this.giveawayHandle,
    };

    try {
      const response = await fetch(this.action, {
        method: this.method,
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          'x-wf-token': this.token,
          'x-wf-value': this.value,
        },
      });

      const data = await response.json();

      if (!data.success) {
        this.handleErrors(
          data.errors || data.error || 'An unknown error occurred'
        );
        return;
      }

      const snakeCaseHandle = this.giveawayHandle.replaceAll('-', '_');

      gtag('event', `additional_entry_${snakeCaseHandle}`, {
        region: this.region,
      })

      this.handleSuccess();
    } catch (error) {
      this.handleErrors(error);
    }
  }

  handleSuccess() {
    this.errors = {};
    this.updateFormState('success', true);
  }

  renderFormElements() {
    return html`
      <div class="giveaway_form_extra_chance_select_container">
        <p class="giveaway_form_reason_label">
          ${window.theme.strings.giveaway.reason_label}
        </p>
        <input
          type="hidden"
          name="orderId"
          value="${this.currentOrder?.order_id}"
        />
        <input type="hidden" name="customerId" value="${this.customerId}" />
        <float-textarea
          name="submission"
          id="submission"
          required
          error="Please enter your reason"
          placeholder="Reason"
          max-words="25"
          maxLength="500"
          single-line
        ></float-textarea>
      </div>
    `;
  }

  renderSuccess() {
    return this.renderInitial();
  }

  renderButton() {
    return html`
      <button
        type="submit"
        class="btn btn-primary"
        aria-label="Submit extra chance giveaway form"
        ?disabled=${this.loading}
        aria-busy=${this.loading ? 'true' : 'false'}
      >
        ${this.loading
          ? html`<bouncing-ellipsis></bouncing-ellipsis>`
          : 'Submit'}
      </button>

      ${this.currentStep.name === 'success'
        ? html`<div class="giveaway_form_extra_chance_success_title_container">
          <h3 class="giveaway_form_extra_chance_success_title">
            ${window.theme.strings.giveaway.extra_chance_success_title}
          </h3>
          <h4 class="giveaway_form_extra_chance_success_subtitle">
            ${window.theme.strings.giveaway.extra_chance_success_subtitle}
          </h4>
        </div>
        <div class="giveaway_form_extra_chance_success_content">
          ${unsafeHTML(window.theme.strings.giveaway.extra_chance_success_html)}
        </div>
      </div>`
        : nothing}
    `;
  }
}

window.customElements.get('giveaway-additional-form') ||
  window.customElements.define(
    'giveaway-additional-form',
    GiveawayAdditionalForm
  );
